import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-card border-t border-white/5 py-16">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="font-heading text-2xl tracking-tight">
              <span className="text-gold">Unbothered</span>
              <span className="text-foreground ml-2 italic">Baddie</span>
            </Link>
            <p className="mt-4 text-muted-foreground text-sm leading-relaxed max-w-md">
              Luxury beauty and accessories for the confident woman. 
              Curated collections that speak to your inner baddie.
            </p>
          </div>

          {/* Shop */}
          <div>
            <h4 className="font-accent text-xs tracking-widest uppercase text-gold mb-4">Shop</h4>
            <ul className="space-y-2">
              {['Makeup', 'Jewelry', 'Body', 'Nails', 'Hair'].map(cat => (
                <li key={cat}>
                  <Link 
                    to={`/shop/${cat.toLowerCase()}`}
                    className="text-sm text-muted-foreground hover:text-gold transition-colors"
                  >
                    {cat}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Help */}
          <div>
            <h4 className="font-accent text-xs tracking-widest uppercase text-gold mb-4">Help</h4>
            <ul className="space-y-2">
              {['Contact', 'Shipping', 'Returns', 'FAQ'].map(item => (
                <li key={item}>
                  <span className="text-sm text-muted-foreground hover:text-gold transition-colors cursor-pointer">
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center">
          <p className="text-xs text-muted-foreground">
            © 2024 Unbothered Baddie. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <span className="text-xs text-muted-foreground hover:text-gold cursor-pointer">Privacy</span>
            <span className="text-xs text-muted-foreground hover:text-gold cursor-pointer">Terms</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
